import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar } from 'lucide-react';
import { formatCurrency } from './performanceUtils';

const PeriodCard = ({ title, iconColor, best, worst, bestLabel, worstLabel }) => (
  <Card className="portfolio-card">
    <CardHeader>
      <CardTitle className="text-lg font-serif flex items-center">
        <Calendar className={`w-5 h-5 mr-2 ${iconColor}`} />
        {title}
      </CardTitle>
      <CardDescription className="body-text">
        Your highest and lowest performing {bestLabel.toLowerCase()}s
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      {best && (
        <div className="flex justify-between items-center p-3 bg-emerald-50 rounded-lg border border-emerald-200">
          <div>
            <p className="text-sm font-medium text-emerald-800">Best {bestLabel}</p>
            <p className="text-xs text-emerald-600">{best.date}</p>
          </div>
          <div className="text-right">
            <p className="font-mono font-bold text-emerald-800" data-sensitive="monetary">+{formatCurrency(best.return)}</p>
            <p className="text-xs text-emerald-600" data-sensitive="rate">+{best.return_percentage.toFixed(2)}%</p>
          </div>
        </div>
      )}
      {worst && (
        <div className="flex justify-between items-center p-3 bg-red-50 rounded-lg border border-red-200">
          <div>
            <p className="text-sm font-medium text-red-800">Worst {worstLabel}</p>
            <p className="text-xs text-red-600">{worst.date}</p>
          </div>
          <div className="text-right">
            <p className="font-mono font-bold text-red-800" data-sensitive="monetary">{formatCurrency(worst.return)}</p>
            <p className="text-xs text-red-600" data-sensitive="rate">{worst.return_percentage.toFixed(2)}%</p>
          </div>
        </div>
      )}
      {!best && !worst && (
        <p className="text-sm text-slate-500 text-center py-4">
          Not enough data to calculate {bestLabel.toLowerCase()} performance
        </p>
      )}
    </CardContent>
  </Card>
);

const PerformanceBestWorst = ({ metrics }) => {
  if (!metrics) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <PeriodCard
        title="Best & Worst Month"
        iconColor="text-indigo-600"
        best={metrics.best_month}
        worst={metrics.worst_month}
        bestLabel="Month"
        worstLabel="Month"
      />
      <PeriodCard
        title="Best & Worst Quarter"
        iconColor="text-purple-600"
        best={metrics.best_quarter}
        worst={metrics.worst_quarter}
        bestLabel="Quarter"
        worstLabel="Quarter"
      />
    </div>
  );
};

export default PerformanceBestWorst;
